import "./CompleteTaskModal.css";

import { Dispatch, FormEvent, SetStateAction, useState } from "react";

import { TaskConstants } from "../../../../constants/workflow/TaskConstants";
import { TaskPanelData } from "../../../../models";
import { ServiceError, Status } from "../../../../service/Shared";
import { updateWorkflowTask } from "../../../../service/workflow";
import { useIsLoadingWrapper } from "../../../../utils";
import { Toast } from "../../../../widget";

interface UseCompleteTaskModalProps {
  closeModal: () => void;
  closePanel: () => void;
  handleRefresh: () => void;
  setErrors: Dispatch<SetStateAction<ServiceError[] | undefined>> | undefined;
  task: TaskPanelData;
}

interface UseCompleteTaskModalReturnData {
  handleCloseModal: () => void;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => Promise<void>;

  setResolution: Dispatch<SetStateAction<string | undefined>>;
  resolution: string | undefined;

  isHandleSubmitLoading: boolean;
}

export const useCompleteTaskModal = ({
  closeModal,
  closePanel,
  handleRefresh,
  setErrors,
  task,
}: UseCompleteTaskModalProps): UseCompleteTaskModalReturnData => {
  const [isHandleSubmitLoading, setIsHandleSubmitLoading] = useState(false);
  const [resolution, setResolution] = useState<string>();
  const handleClosePanel = (): void => {
    setResolution(undefined);
    if (setErrors) setErrors([]);
    closePanel();
  };

  const handleCloseModal = (): void => {
    setResolution(undefined);
    closeModal();
  };

  const handleSubmit = useIsLoadingWrapper(async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();

    if (resolution) {
      const res = await updateWorkflowTask({
        assignedToUserUuid: task.assignedToUserUuid,
        deadlineDate: task.deadlineDate,
        description: task.description,
        isMandatory: task.isMandatory ?? false,
        isMilestone: task.isMilestone ?? false,
        keyDate: task.keyDate,
        name: task.name ?? "",
        objectType: task.relateToActivity ? "Activity" : null,
        objectUuid: task.activityUuid,
        reminderDate: null,
        reminderType: null,
        repeat: task.repeat ?? false,
        visibility: task.visibility ?? [],
        ownerOrganisationUuid: task.ownerOrganisationUuid ?? "",
        rowVersion: task.rowVersion ?? 1,
        resolution,
        status: TaskConstants.TASK_STATUS_COMPLETE,
        workflowTaskUuid: task.uuid ?? "",
        workflowStepUuid: task.stepUuid ?? "",
      });
      if (res.status === Status.Success && res.data) {
        Toast.success({
          message: `Workflow task completed successfully`,
        });
        handleRefresh();
        handleClosePanel();
      }

      if (res.status === Status.Error && res.errors) {
        if (setErrors) setErrors(res.errors);
        handleCloseModal();
      }
    }
  }, setIsHandleSubmitLoading);

  return {
    handleCloseModal,
    handleSubmit,
    setResolution,
    resolution,
    isHandleSubmitLoading,
  };
};
